export default __webpack_public_path__ + "static/redstonearchives-aa4ab574681e953b33553a41efc95400.gif";